export default __webpack_public_path__ + "locales/sr-Latn-RS/EmptyView.json?hash=843e38b6a07584e4e53a358062e7a796";